module.exports = __webpack_public_path__ + "static/media/invitation-scb-header.ad8bba6c.png";